const safeProtocols: string[] = ["http:", "https:", "ftp:", "mailto:"];

export default safeProtocols;
